import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, ShoppingBag, Home, Package } from 'lucide-react';

const OrderConfirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { orderId, orderTotal, firebaseOrderId } = location.state || {};

    useEffect(() => {
        if (!orderId) {
            navigate('/');
        }
    }, [orderId, navigate]);

    if (!orderId) {
        return null;
    }

    return (
    
        <div className="min-h-screen bg-beige p-6">
            <div className="text-center mb-8">" "

            </div>
            <div className="max-w-4xl mx-auto">
                <div className="bg-offwhite rounded-lg p-8 shadow-sm border border-taupe/30 text-center">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="bg-green-100 rounded-full p-4">
                            <CheckCircle size={48} className="text-green-600" />
                        </div>
                    </div>

                    {/* Success Message */}
                    <h1 className="text-3xl font-bold text-charcoal mb-4">
                        Order Placed!
                    </h1>
                    <p className="text-lg text-charcoal/70 mb-2">
                        Thank you for your purchase!
                    </p>
                    <p className="text-charcoal/60 mb-6">
                        Your order has been successfully placed and is being processed.
                    </p>

                    {/* Order Details */}
                    <div className="bg-beige rounded-lg p-6 mb-6 max-w-md mx-auto">
                        <div className="grid grid-cols-2 gap-4 text-sm">
                            <div className="text-left">
                                <span className="text-charcoal/60">Order ID:</span>
                                <div className="font-semibold text-charcoal">{orderId}</div>
                            </div>
                            <div className="text-right">
                                <span className="text-charcoal/60">Total Amount:</span>
                                <div className="font-semibold text-charcoal">PKR {orderTotal}</div>
                            </div>
                        
                        </div>
                    </div>

                    {/* Next Steps */}
                    <div className="bg-blue-50 rounded-lg p-6 mb-8 max-w-2xl mx-auto">
                        <h2 className="text-lg font-semibold text-charcoal mb-3">
                            What's Next?
                        </h2>
                        <div className="space-y-2 text-sm text-charcoal/70 text-left">
                            <div className="flex items-center space-x-2">
                                <Package size={16} className="text-primary" />
                                <span>You will receive an order confirmation email shortly</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <ShoppingBag size={16} className="text-primary" />
                                <span>Your order will be delivered within 3-5 business days</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <CheckCircle size={16} className="text-primary" />
                                <span>Pay with cash when your order arrives</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <CheckCircle size={16} className="text-primary" />
                                <span>Product stock has been automatically updated</span>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/"
                            className="flex items-center justify-center space-x-2 bg-primary text-offwhite px-6 py-3 rounded-lg hover:bg-primary-dark transition-colors font-semibold"
                        >
                            <Home size={20} />
                            <span>Back to Home</span>
                        </Link>
                        <Link
                            to="/shop"
                            className="flex items-center justify-center space-x-2 border border-primary text-primary px-6 py-3 rounded-lg hover:bg-primary/10 transition-colors font-semibold"
                        >
                            <ShoppingBag size={20} />
                            <span>Continue Shopping</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderConfirmation;